/**
 * StatusPausedIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const StatusPausedIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2m-1 13a1 1 0 1 1-2 0V9a1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0V9a1 1 0 1 1 2 0z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const StatusPausedIcon = makeIcon('StatusPausedIcon', StatusPausedIconSvg)
